import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {staticPagesView_template} from  "../components/templates/staticPagesView_template";

declare var ko: any;
declare var page: any;

export class static_page_view extends vnModule_knockoutJS {

    protected staticPagesView: staticPagesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.staticPagesView = new staticPagesView_template("static_page_view_template", this.viewModel, this);
        return [this.staticPagesView.build()];
    }

    protected getModuleName(): string {
        return "static_page_view";
    }

    fillPage() {
        this.getStaticPageDataForView()
    }

    private getStaticPageDataForView() {

        this.loadingIn(this.staticPagesView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/staticpage/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetStaticPageDataForView;
        this.XHRHdl.execute();
    }

    private onGetStaticPageDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let staticpage = responseParsed.data
                obj.staticPagesView.setStaticPageData(staticpage);
                let versions = responseParsed.versions || [];
                obj.staticPagesView.setVersions(versions);

            });

            obj.loadingOut(obj.staticPagesView.builtTemplate);
        }
    }

    public downloadVersion(version) {
        let url : string = 'https://'+window.location.hostname+'/api/brand/' + this.getVnAppZone().app.params.idBrand + '/staticpage/version/' + version.id + '/download/';
        
        // Create a temporary link to trigger download
        let link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    protected onClickEditStaticPage(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/config/static-pages/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/static-pages/")
    }

}



// WEBPACK FOOTER //
// ./js/modules/static_page_view.ts